import { PipelineStage } from "./types";

export type PipelineColumnConfig = {
  stage: PipelineStage;
  title: string;
  borderColor: string;
  badgeColor: string;
  badgeTextColor: string;
};

export const PIPELINE_COLUMNS: PipelineColumnConfig[] = [
  {
    stage: "new_orders",
    title: "New Orders",
    borderColor: "#1E88E5",
    badgeColor: "#E3F2FD",
    badgeTextColor: "#1565C0",
  },
  {
    stage: "pending_confirmation",
    title: "Pending Confirmation",
    borderColor: "#FBC02D",
    badgeColor: "#FFF9C4",
    badgeTextColor: "#F57F17",
  },
  {
    stage: "scheduled_confirmed",
    title: "Scheduled & Confirmed",
    borderColor: "#43A047",
    badgeColor: "#E8F5E9",
    badgeTextColor: "#2E7D32",
  },
  {
    stage: "picked_up",
    title: "Picked Up",
    borderColor: "#8E24AA",
    badgeColor: "#F3E5F5",
    badgeTextColor: "#7B1FA2",
  },
  {
    stage: "delivery_verified",
    title: "Delivery Verified",
    borderColor: "#BDBDBD",
    badgeColor: "#F5F5F5",
    badgeTextColor: "#757575",
  },
];

const MANUAL_STAGE_CHANGE_BLOCKED = new Set<PipelineStage>(["new_orders", "pending_confirmation"]);

export function allowsManualStageChange(stage: PipelineStage): boolean {
  return !MANUAL_STAGE_CHANGE_BLOCKED.has(stage);
}

export const NEXT_STAGE: Partial<Record<PipelineStage, PipelineStage>> = {
  new_orders: "pending_confirmation",
  pending_confirmation: "scheduled_confirmed",
  scheduled_confirmed: "picked_up",
  picked_up: "delivery_verified",
};

export const PREVIOUS_STAGE: Partial<Record<PipelineStage, PipelineStage>> = {
  scheduled_confirmed: "pending_confirmation",
  picked_up: "scheduled_confirmed",
  delivery_verified: "picked_up",
};
